/**
 * Name of fields on Billing page
 */

export const CARD_NAME = 'cardName';
export const CARD_NUMBER = 'cardNumber';
export const EXPIRY = 'EXPIRY';
export const CVV = 'CVV';
